<template>
  <div class="button-group-demo">
    <!-- 按钮组 -->
    <div class="custom-button-group" v-show="false">
      <button
          v-for="(button, index) in buttons"
          :key="index"
          :class="['custom-button', { active: selectedButton === index }]"
          @click="selectButton(index)"
      >
        {{ button.label }}
      </button>
    </div>

    <keep-alive>
      <component :is="buttons[selectedButton].component"></component>
    </keep-alive>

  </div>
</template>

<script>
import KVList from '@/components/checklist/kvChecklist.vue';


export default {
  components: {
    KVList
  },
  data() {
    return {
      // 按钮数据，每个按钮绑定一个组件
      buttons: [
        {label: "参数对比", component: "KVList"},
        // {label: "备注对比", component: "KVList"},
        // {label: "阻抗对比", component: "KVList"},
        // {label: "压合结构对比", component: "KVList"},
        // {label: "丝印层", component: "SilkScreenLayer"},
        // {label: "其它层", component: "OtherLayer"},
      ],
      selectedButton: 0, // 默认选中第一个按钮
    };
  },
  methods: {
    // 处理按钮点击事件
    selectButton(index) {
      this.selectedButton = index;
    },
  },
};
</script>


<style scoped>
/* 按钮组容器 */
.custom-button-group {
  display: flex;
  position: relative;
  align-items: center;
  gap: 24px; /* 按钮间距 */
}

/* 自定义按钮样式 */
.custom-button {
  background-color: #ffffff;
  padding: 3px 7px;
  border: none; /* 去掉边框 */
  border-radius: 5px; /* 设置按钮圆角 */
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.3s, color 0.3s;
}

.custom-button:hover {
  background-color: #e0e0e0;
}

/* 选中按钮样式 */
.custom-button.active {
  background-color: #409eff; /* 激活状态颜色 */
  color: #fff;
}

</style>
